import { Builder } from 'builder-pattern';

export class ScoreTableItem {
  label: string;
  level: number;
  order: number;
  score: string;
  value: number;

  public static createScoreObject(
    score: string,
    label: string,
    value: any,
    level: number,
    order: number
  ): ScoreTableItem {
    return Builder(ScoreTableItem)
      .score(score)
      .label(label)
      .value(value)
      .level(level)
      .order(order)
      .build();
  }
}
